import { render, staticRenderFns } from "./wtOrganizationsDropdown.component.vue?vue&type=template&id=be15f71c&"
import script from "./wtOrganizationsDropdown.component.vue?vue&type=script&lang=js&"
export * from "./wtOrganizationsDropdown.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports